enum HTTP_METHOD {
  POST = "post",
  GET = "get",
  DELETE = "delete",
  PUT = "put",
  PATCH = "patch",
}
export default HTTP_METHOD;
